




























import Vue, { VueConstructor } from "vue";
import axios from "../../../rest.config";
import Sidenav from "@/components/Navigation/SideNav.vue";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      sidenav: {
        openNav(): void;
        closeNav(): void;
        isOpen: boolean;
      };
      topnav: {
        style: CSSStyleDeclaration;
        clientHeight: number;
      };
      start: {
        clientHeight: number;
      };
      nav: {
        children: HTMLElement[];
      };
    };
  }
>).extend({
  components: {},
  data() {
    return {
      loggedIn: false,
      navToggle: false,
      marginTop: 15
    };
  },
  async created() {
    await this.$store.dispatch("checkStatus");
  },
  computed: {
    isLoggedIn: function() {
      //  console.log("check lolgin");
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
    user: function() {
      return this.$store.getters.user;
    },
    classToggle: function(): any {
      return {
        topnav__ToggleShow: this.navToggle
      };
    },
    version: function(): string {
      let version = "1";
      return version;
    }
  },
  methods: {
    openNav: function(): void {
      this.$emit("toggle-nav");
    },
    loginout: function(): void {
      if (this.isLoggedIn) {
        this.$router.push({ name: "logout" }).catch(error => {});
      } else {
        this.$router.push("/login").catch(error => {});
      }
    },
    play: function(): void {
      this.$router.push({ name: "play" }).catch(() => {});
    },
    goto: function(route: string): void {
      this.$router.push({ name: route }).catch(() => {});
    }
  },
  mounted() {},
  watch: {
    "$route.path": function() {
      // this.closeNav();
    }
  }
});
